import { NestedKeyof, ResolveByNestedKey } from 'shared/components/table/utils/nested-keyof-utils';

export const descendingComparator = <T extends object, K extends NestedKeyof<T>>(a: T, b: T, orderBy: K): number => {
  const valA = ResolveByNestedKey<T>(orderBy, a) as number | string;
  const valB = ResolveByNestedKey<T>(orderBy, b) as number | string;
  if (valB < valA) return -1;
  if (valB > valA) return 1;
  return 0;
};

export const descendingCaseInsensitiveStringComparator = <T extends object, K extends NestedKeyof<T>>(a: T, b: T, orderBy: K): number => {
  const valueOfA = ((ResolveByNestedKey<T>(orderBy, a) as string) ?? '').toLowerCase();
  const valueOfB = ((ResolveByNestedKey<T>(orderBy, b) as string) ?? '').toLowerCase();
  if (valueOfB < valueOfA) return -1;
  if (valueOfB > valueOfA) return 1;
  return 0;
};
